import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';

import { CreateTributeCard } from '@modules/Tributes/components/CreateTributeCard';
import { Box } from '@mui/material';


export const OrderTributeCard: React.FC = () => {
  const { tributeId } = useParams();
  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100%" />}>
        <Box mt={2} width="100%">
          <CreateTributeCard tributeId={tributeId} />
        </Box>
      </Suspense>
    </ErrorBoundary>
  );
};
